// extracted by mini-css-extract-plugin
export default {"tooltip":"TT-z","arrow":"UT-z"};